module.exports = __webpack_public_path__ + "img/r-108.1fae1704.jpg";